import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataAddModalResult } from "../component/DataAddModalResult";
import { FollowCallModal } from "../component/tableFunction/FollowCallModal";
import { FollowCallStartStopModal } from "../component/tableFunction/FollowCallStartStopModal";
import { GetXLSXFollowCallModal } from "../component/GetXLSXFollowCallModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getFollowCalls,
  putFollowCallStatus,
  putFollowCallCall,
} from "../api/followCall";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchAccountSales,
  getProductCandidatesEntry,
} from "../api/serch";

// InterFace
import { followCallTableColumn } from "../config/followCall";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function FollowCall() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "フォローアップ一覧出力",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {}, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "フォローアップ一覧出力") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルの一覧をメインテーブルの詳細表示（エントリーフォーム用）
  const [getSubMainTableDetail, setGetSubMainTableName] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {}, [getSubMainTableDetail.name, getSubMainTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "停止・再開") {
      setStartStopDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "フォローコール") {
      setCallDataInf({
        ...callDataInf,
        status: "open",
        key: tableOriginalFunc.key,
        follow_call_hope_time:
          tableOriginalFunc.key.follow_call_hope_time === "-"
            ? ""
            : tableOriginalFunc.key.follow_call_hope_time,
        follow_call_memo:
          tableOriginalFunc.key.follow_call_memo === "-"
            ? ""
            : tableOriginalFunc.key.follow_call_memo,
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = followCallTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >(
    followCallTableColumn.dataColumn
      .filter((column) => {
        return column.sort;
      })
      .map((column) => {
        return {
          key: column.key,
          sort: "DESC",
        };
      })
  );

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getFollowCalls(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn
    );
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.followCalls);
      const countFollowCalls = Number(fetchData.countFollowCalls);
      setTotalCount(countFollowCalls);
      setMaxPageNumber(Math.ceil(countFollowCalls / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // フォローコール停止・再開
  const [startStopDataInf, setStartStopDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function startStopData() {
    setStartStopDataInf({
      ...startStopDataInf,
      status: "loading",
    });
    const id = startStopDataInf.key.id;
    const startStop = startStopDataInf.key.startStop;
    const responce = await putFollowCallStatus(id, startStop);
    if (responce == "success") {
      await getTableData(false);
      setStartStopDataInf({
        ...startStopDataInf,
        status: "success",
      });
    } else {
      setStartStopDataInf({
        ...startStopDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (startStopDataInf.status === "loading") {
      setIsLoading(true);
    } else if (startStopDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [startStopDataInf]);

  // フォローコール
  const [callDataInf, setCallDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  }>({
    status: null,
    key: {},
    message: "",
    follow_call_status: null,
    follow_call_hope_date: "",
    follow_call_hope_time: "",
    follow_call_memo: "",
  });
  async function callData() {
    setCallDataInf({
      ...callDataInf,
      status: "loading",
    });
    const id = callDataInf.key.id;
    const responce = await putFollowCallCall(
      id,
      callDataInf.follow_call_status,
      callDataInf.follow_call_hope_date,
      callDataInf.follow_call_hope_time,
      callDataInf.follow_call_memo
    );
    if (responce == "success") {
      await getTableData(false);
      setCallDataInf({
        ...callDataInf,
        status: "success",
      });
    } else {
      setCallDataInf({
        ...callDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (callDataInf.status === "loading") {
      setIsLoading(true);
    } else if (callDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [callDataInf]);

  // 明細Excel取得
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    follow_call_status: number[];
    all_follow_call_status: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    follow_call_start_year: string;
    follow_call_start_month: string;
    follow_call_end_year: string;
    follow_call_end_month: string;
    follow_call_all_year: boolean;
  }>({
    status: "none",
    message: "",
    follow_call_status: [],
    all_follow_call_status: false,
    sale_company_id: null,
    sale_company_name: "",
    all_company: false,
    product_id: null,
    product_name: "",
    all_product: false,
    follow_call_start_year: lastYear.toString(),
    follow_call_start_month: lastMonth.toString(),
    follow_call_end_year: thisYear.toString(),
    follow_call_end_month: thisMonth.toString(),
    follow_call_all_year: false,
  });

  async function getPaymentsXLSX() {
    const idToken = loginUser?.idToken;
    const produntName = getXLSXStatus.all_product
      ? "全商材"
      : getXLSXStatus.product_name;

    const companyName = getXLSXStatus.all_company
      ? "全社"
      : getXLSXStatus.sale_company_name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const fileName =
      loginUser?.authority !== "パートナー" &&
      loginUser?.authority !== "営業アカウント"
        ? "【フォローコール一覧】商材:" +
          produntName +
          "_パートナー企業:" +
          companyName +
          "_" +
          nowTimeName +
          ".xlsx"
        : "【フォローコール一覧】商材:" +
          produntName +
          "_" +
          nowTimeName +
          ".xlsx";
    const bodys = {
      type: "get_xlsx_follow_call",
      sale_company_id: getXLSXStatus.sale_company_id,
      sale_company_name: getXLSXStatus.sale_company_name,
      follow_call_status: getXLSXStatus.follow_call_status,
      all_follow_call_status: getXLSXStatus.all_follow_call_status,
      all_company: getXLSXStatus.all_company,
      product_id: getXLSXStatus.product_id,
      product_name: getXLSXStatus.product_name,
      all_product: getXLSXStatus.all_product,
      follow_call_start_year: getXLSXStatus.follow_call_start_year,
      follow_call_start_month: getXLSXStatus.follow_call_start_month,
      follow_call_end_year: getXLSXStatus.follow_call_end_year,
      follow_call_end_month: getXLSXStatus.follow_call_end_month,
      follow_call_all_year: getXLSXStatus.follow_call_all_year,
      idToken,
      fileName,
    };
    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXFollowCallsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "エントリー一覧出力完了",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[]
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        }
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
      product_key: string;
    }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
          product_key: string;
        }[]
      );
    }
  }
  async function getProductNameListFromHistory() {
    const products = await getProductCandidatesEntry();
    if (products) {
      const names: string[] = [""];
      for (const p of products) {
        if (p.product_name && !names.includes(p.product_name)) {
          names.push(p.product_name);
        }
      }
      setProductNameList(names);
    }
  }
  // 営業アカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[]
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        }
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getProductNameListFromHistory();
    getSaleAccountSalesList();
    getSaleCompanysList();
  }, []);

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }} data-testid="follow-call-page">
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={followCallTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={() => {}}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={setGetSubSubTableAdd}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={followCallTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={setGetSubMainTableName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={followCallTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={[]}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="FollowCall"
          />
        )}
      </Box>
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <FollowCallStartStopModal
        onModal={
          startStopDataInf.status !== null &&
          startStopDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setStartStopDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        startStopDataInf={startStopDataInf}
        setStartStopDataInf={setStartStopDataInf}
        startStopData={startStopData}
      />
      <FollowCallModal
        onModal={
          callDataInf.status !== null && callDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setCallDataInf({
            status: null,
            key: {},
            message: "",
            follow_call_status: null,
            follow_call_hope_date: "",
            follow_call_hope_time: "",
            follow_call_memo: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        callDataInf={callDataInf}
        setCallDataInf={setCallDataInf}
        callData={callData}
      />
      <GetXLSXFollowCallModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => {
          setGetXLSXStatus({
            status: "none",
            message: "",
            follow_call_status: [],
            all_follow_call_status: false,
            sale_company_id: null,
            sale_company_name: "",
            all_company: false,
            product_id: null,
            product_name: "",
            all_product: false,
            follow_call_start_year: lastYear.toString(),
            follow_call_start_month: lastMonth.toString(),
            follow_call_end_year: thisYear.toString(),
            follow_call_end_month: thisMonth.toString(),
            follow_call_all_year: false,
          });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getPaymentsXLSX}
        firstYear={firstYear}
        thisYear={thisYear}
        thisMonth={thisMonth}
        lastYear={lastYear}
        lastMonth={lastMonth}
        companyList={companyList}
        productList={productList}
      />
    </Box>
  );
}

export default FollowCall;
